__turbopack_context__.v({
  "desktopContainer": "V1EnterLayout-module__7MRjVq__desktopContainer",
  "desktopLeft": "V1EnterLayout-module__7MRjVq__desktopLeft",
  "desktopRight": "V1EnterLayout-module__7MRjVq__desktopRight",
});
